import { Box, Typography } from "@mui/material";

const BottomBar = () => {
  return (
    <Box
      className="bottombar"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ display: { xs: "none", md: "flex" } }}
    >
      <Typography variant="body2" color="text.secondary">
        Made with ❤️ by LayaFood
      </Typography>
      <Typography variant="body2" color="text.secondary">
        © 2026 | All Rights Reserved
      </Typography>
    </Box>
  );
};

export default BottomBar;
